/**
 * Validacion de los datos del ganador, compartida por el navegador y las
 * Functions: el cliente avisa antes de enviar y el servidor no se fia, pero
 * ambos aplican exactamente la misma regla y el mismo mensaje.
 */

/**
 * De que premio se piden los datos del ganador. Solo del premio gordo: es el
 * unico que hay que entregar a una persona concreta, y pedir nombre y correo
 * por una taza espantaria a media cola del stand.
 *
 * Va por id, no por etiqueta: el operador puede reescribir el texto en /config
 * sin romper esto. Si algun dia se renombran los ids o el premio gordo pasa a
 * ser otro, este es el unico sitio que hay que tocar.
 */
export const CONTACT_PRIZE_IDS: readonly string[] = ['premio_1'];

/** true si el ganador de este premio tiene que dejar sus datos. */
export function needsContact(prizeId: string | null): boolean {
  return prizeId !== null && CONTACT_PRIZE_IDS.includes(prizeId);
}

/** Topes de longitud. Cortos a proposito: el log entero vive en un unico
 *  valor de KV, y un campo libre sin limite es la via facil para inflarlo. */
export const NAME_MAX = 80;
export const EMAIL_MAX = 120;

export interface ClaimInput {
  name: string;
  email: string;
  /** La casilla de autorizacion. Sin ella no se guarda ningun dato. */
  consent: boolean;
}

/**
 * Email "suficientemente bueno": una sola arroba, algo a cada lado y al menos
 * un punto en el dominio. No se afina mas porque el unico juez de verdad es
 * escribir al correo; de lo que se trata aqui es de cazar erratas.
 */
const EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

/** Colapsa espacios: los nombres se teclean con prisa en una tablet. */
export function cleanName(raw: unknown): string {
  return typeof raw === 'string' ? raw.replace(/\s+/g, ' ').trim() : '';
}

export function cleanEmail(raw: unknown): string {
  return typeof raw === 'string' ? raw.trim() : '';
}

/**
 * null si los datos valen; si no, el motivo tal cual se ensena al ganador.
 * El orden de las comprobaciones es el de los campos en pantalla.
 */
export function claimError({ name, email, consent }: ClaimInput): string | null {
  if (!name) return 'Please enter your name.';
  if (name.length > NAME_MAX) return `Your name can be at most ${NAME_MAX} characters.`;
  if (!email) return 'Please enter your email.';
  if (email.length > EMAIL_MAX) return `Your email can be at most ${EMAIL_MAX} characters.`;
  if (!EMAIL_RE.test(email)) return 'That email does not look right.';
  if (!consent) return 'Please tick the authorisation to continue.';
  return null;
}
